import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import alpha from './test1'
// import { beta, charlie } from './test2'
import * as Test2 from './test2'

Vue.config.productionTip = false

const vm = new Vue({
  // el: '#app',
  data: function() {
    return {
      test: 'My cheekbones are evolving into trees'
    }
  },
  router,
  store,
  render: h => h(App)
}).$mount('#app')

alpha()
// beta()
// charlie()
Test2.beta()
Test2.charlie()

vm_main = vm;